import { TemplateForm } from '../components/Settings/ManageTemplates/TemplateForm/TemplateForm'

export const TemplateFormPage = () => {
    return <TemplateForm />
}
